import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ResponsiveBreakpointsDataPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (
    publicMethodUtils: PublicMethodUtils
): PublicModuleDeclaration<ResponsiveBreakpointsDataPublicAPI> {
    const {
        extensionPublicAPI: {getter}
    } = publicMethodUtils
    return {
        methods: {
            responsiveBreakpointsData: {
                getTrainingData: getter('responsiveBreakpointsData.getTrainingData')
            }
        }
    }
}
